<template>
  <div class="blog white_box">
    <div class="widget_header">
      <h3 class="heading">
        Read the latest from our blog
      </h3>
    </div>
    <div class="blog_items">
      <div
        v-for="(blog, index) in blogs"
        :key="index"
        class="blog_item"
      >
        <a
          :href="blog.url"
          class="text-dark"
          target="_blank"
        >
          <p class="text-center">
            <img
              :src="blog.image"
              class="img-fluid"
              style="height:170px;"
            >
          </p>
          <p class="xs-mb-0"><u>{{ blog.title }}</u></p>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  computed: {
    ...mapGetters('dashboard', [
        'blogs',
    ]),
  },
  mounted() {
    this.getBlogs();
  },
  methods: {
    ...mapActions('dashboard', [
        'getBlogs',
    ]),
  },
}
</script>

<style scoped>
.blog.white_box {
  margin-top: 1rem;
}

.blog_items {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 30px;
}

.blog_item {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
